import { render, staticRenderFns } from "./VirtualTableHeader.vue?vue&type=template&id=36520a74&scoped=true"
import script from "./VirtualTableHeader.vue?vue&type=script&lang=js"
export * from "./VirtualTableHeader.vue?vue&type=script&lang=js"
import style0 from "./VirtualTableHeader.vue?vue&type=style&index=0&id=36520a74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36520a74",
  null
  
)

export default component.exports